import React from 'react';
import styled from 'styled-components';
import Table from '../../_Shared/Table';
import moment from 'moment';
import { WidgetContentItem } from '../../_Shared/Elements';
import { FaTrash as Trash } from '@react-icons/all-files/fa/FaTrash';
import Dropdown from '../../_Shared/DropdownWrapper';
import { IoEllipsisHorizontal } from '@react-icons/all-files/io5/IoEllipsisHorizontal';
import Api, { Actions, Endpoints } from '../../_Shared/Api';
import { AiOutlineSearch } from '@react-icons/all-files/ai/AiOutlineSearch'
import Tablev2 from '../../_Shared/Tablev2';

const Companies = (props: any) => {
  const { results } = props.data.companies;
  const { UpdateSelf } = props.actions;
  const { getCompanies } = props;

  const handleClick = (data: any) => {
    UpdateSelf({ screen: 'company', company_id: data.id });
  };

  const deleteCompany = async (id: string, e: any) => {
    await Api(Endpoints['Hubspot'], Actions['RemoveCompany'], props.external_token, {}, [
      ['companyId', id],
    ]);
    getCompanies();
  };

  return (
    <>
      <SpaceWrapper>
        <Button className='button default' onClick={() => UpdateSelf({ screen: 'createCompany' })} ref={props.useRef}>
          Create Company
        </Button>
      </SpaceWrapper>
      <Header className="text-primary">Company</Header>
      <SubHeader className="text-secondary">{results?.length ?? 0} records</SubHeader> 
      {/* <SearchDiv>
          <AiOutlineSearch size="22px" />
          <SearchInput onChange={(e) => //console.log(e.target.value)} className="topbar" type='text' placeholder='Search' />
      </SearchDiv> */}

      <Tablev2
        columns={[{
            Header: 'Name',
            accessor: '',
            Cell: ({ original }) => `${original?.properties?.name ?? '-'}`
          }, {
            Header: 'Domain',
            accessor: '',
            Cell: ({ original }) => `${original?.properties?.domain ?? '-'}`
          }, {
            Header: 'Industry',
            accessor: '',
            Cell: ({ original }) => `${original?.properties?.industry ?? '-'}`
          },{
            Header: 'Last Activity',
            accessor: '',
            Cell: ({ original }) => `${moment(original?.properties?.hs_lastmodifieddate).format('LLL')}`
          },{
            Header: '',
            accessor: '',
            width: 60,
            Cell: ({ original }) => {
              const DropdownContent = (props: any) => {
                return (
                  <React.Fragment>
                    <WidgetContentItem
                      padding={10}
                      onClick={(e: any) => {
                        deleteCompany(original.id, e);
                        props.onClose();
                      }}
                    >
                      <Trash width={16} className='error' />
                      Remove Company
                    </WidgetContentItem>
                  </React.Fragment>
                );
              };
              return (
                <Dropdown items={DropdownContent}>
                  <IoEllipsisHorizontal width={16} style={{ fontSize: '16px' }} />
                </Dropdown>
              );
            }
          }
        ]}
        data={results || []}
        showPagination={false}
        sortable={false}
        onRowClick={(row: any) => handleClick(row)}
      />
      {/* <CTable
        headers={[
          {
            label: 'Name',
            width: '20%',
            row: (row: any) => {
              const { name } = row.properties;
              return <Assignees>{name}</Assignees>;
            },
          },
          {
            label: 'Domain',
            width: '30%',
            row: (row: any) => {
              const { domain } = row.properties;
              return <Assignees>{domain}</Assignees>;
            },
          },
          {
            label: 'Industry',
            width: '30%',
            row: (row: any) => {
              const { industry } = row.properties;
              return <Assignees>{industry}</Assignees>;
            },
          },
          {
            label: 'Last Activity',
            width: '40%',
            row: (row: any) => {
              const { hs_lastmodifieddate } = row.properties;
              return <Assignees>{moment(hs_lastmodifieddate).format('LLL')}</Assignees>;
            },
          },
          {
            label: '',
            value: '',
            row: (row: any) => {
              const DropdownContent = (props: any) => {
                return (
                  <React.Fragment>
                    <WidgetContentItem
                      padding={10}
                      onClick={(e: any) => {
                        deleteCompany(row.id, e);
                        props.onClose();
                      }}
                    >
                      <Trash width={16} className='error' />
                      Remove Company
                    </WidgetContentItem>
                  </React.Fragment>
                );
              };
              return (
                <Dropdown items={DropdownContent}>
                  <IoEllipsisHorizontal width={16} style={{ fontSize: '16px' }} />
                </Dropdown>
              );
            },
            width: '5%',
          },
        ]}
        data={results || []}
        // expandingData={taskChild}
        parentKey='id'
        onClick={(row: any) => handleClick(row)}
        expandingRowClick={(row: any) => handleClick(row)}
      /> */}
    </>
  );
};

export default Companies;

const SpaceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  left: 0;
`;


const Button = styled.div`
  text-align: center;
  cursor: pointer;
  font-weight: ${(props) => props.theme.textBold};
  margin: 0 2px;
  display: none;

  &.custom-padding {
    padding: 10px 15px !important;
    font-size: 12px;
    margin: 0 10px;
  }

  transition: box-shadow 0.3s ease-out;
  &:hover {
    box-shadow: ${(props) => props.theme.shadows.neumorphiclight};
  }
`;


const Assignees = styled.div`
  display: flex;
  flex-direction: row-reverse;

  & > div:not(:last-child) {
    margin-left: -10px;
  }

  & > div {
    transition: 0.3s transform ease-out;
    border: 1px solid white;
    &:hover {
      z-index: 2;
      border: 1px solid white;
      transform: scale(1.1);
    }
  }
`;

const Header = styled.div`
  font-weight: bold;
  font-size: 20px;
`

const SubHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  margin-bottom: 15px;
`

const SearchInput = styled.input`
  box-sizing: border-box;
  height: 40px;
  width: 294px;  
  background-color: transparent !important;
  outline: none;
  border: none;
`

const SearchDiv = styled.div`
  align-items: center;
  border-radius: 999px;
  border: 1px solid #6F6868; 
  display: flex;
  padding: 2px;
  margin-right: 5px;
  margin-top: 30px;
  margin-bottom: -30px;
  width: 294px;  
  padding-left: 10px;
`

const CTable = styled(Table)`
    display: block;
    overflow-x: auto;
    white-space: nowrap;
`